import React, { useState } from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { Box, Button, Typography } from "@mui/material";
import {
  CancelButton,
  UpdateButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { useSelector, useDispatch } from "react-redux";
import { completeCycle } from "../../../../../redux/features/appraisalSlice";
import useHandleApiResponse from "../../../../../Hooks/useHandleApiResponse";

const CompleteRestartCycle = ({ id }) => {
  const handleApiResponse = useHandleApiResponse();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { loading } = useSelector((state) => state.appraisal);

  const handleComplete = () => {
    dispatch(completeCycle(id)).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          setOpen(false);
        },
        onFailed: () => {
          console.log("Something went wrong");
        },
      });
    });
  };
  return (
    <Box>
      <GlobalDialog
        title={"Complete Cycle"}
        open={open}
        setOpen={setOpen}
        closeButton={true}
        popupButton={
          <Button
            variant="contained"
            size="small"
            sx={{ borderRadius: 3 }}
            onClick={() => setOpen(true)}
          >
            Complete Cycle
          </Button>
        }
        content={
          <Box>
            <Typography>
              Are you sure ? you want complete this cycle........!
            </Typography>
          </Box>
        }
        actionButton={
          <>
            <CancelButton size={"small"} action={() => setOpen(false)}>
              Cancel
            </CancelButton>
            <UpdateButton
              action={handleComplete}
              disabled={loading}
              size={"small"}
            >
              {loading ? "Please wait..." : "Complete"}
            </UpdateButton>
          </>
        }
      />
    </Box>
  );
};

export default CompleteRestartCycle;
